{
    "coordinates": [
        -15.8756979887564,
        46.63235597907419
    ],
    "tooltip": "Maevarano",
    "title": "Maevarano Formation",
    "country": "Madagascar",
    "period": "Cretaceous",
    "alt": "TODO"
}
